import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { PermissionState } from './state'
import { Mutations } from './mutations'
import { PermissionMutationType } from './mutation-types'
import { PermissionActionType } from './action-types'
import { RouteRecordRaw } from 'vue-router'
import router from '@/router'

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>
} & Omit<ActionContext<PermissionState, RootState>, 'commit'>

export interface Actions {
  [PermissionActionType.ACTION_SET_ROUTES]({ commit }: AugmentedActionContext, roles: string): void
}

export const actions: ActionTree<PermissionState, RootState> & Actions = {
  [PermissionActionType.ACTION_SET_ROUTES]({ commit }: AugmentedActionContext, roles: string) {
    const accessedRoutes: RouteRecordRaw[] = []
    // if (roles.includes('admin')) {
    //   accessedRoutes = asyncRoutes
    // } else {
    const arrRoutes = filterAsyncRoutes(router.getRoutes(), roles)
    arrRoutes.forEach((route) => {
      if (route?.meta?.parent == roles) {
        accessedRoutes.push(route)
      }
    })
    // }
    commit(PermissionMutationType.SET_ROUTES, accessedRoutes)
  },
}

export const filterAsyncRoutes = (routes: RouteRecordRaw[], roles: string) => {
  const res: RouteRecordRaw[] = []
  routes.forEach((route) => {
    const r = { ...route }
    if (hasPermission(roles, r) && r?.meta?.showMenu) {
      if (r.children) {
        r.children = filterAsyncRoutes(r.children, '')
      }
      res.push(r)
    }
  })
  return res
}

const hasPermission = (roles: string, route: RouteRecordRaw) => {
  return true
}
